import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const chevronDown: ISVGPersonalProps = {
  viewBox: '0 0 105.167 61.651',
  content: (
    <path
      fill="currentColor"
      d="M2.868 3.155c3.955-4.046 9.458-4.363 14.291 0l35.434 33.971L88.026 3.155c4.834-4.363 10.347-4.046 14.269 0a10.77 10.77 0 0 1 0 14.643c-3.683 3.791-42.568 40.817-42.568 40.817a9.917 9.917 0 0 1-14.286 0S6.574 21.589 2.874 17.798a10.764 10.764 0 0 1 0-14.643Z"
    />
  ),
};
